export const RecommendedLayerThicknesses = {
  '22': 100,
  '24': 100,
  StudyModelSmileDesign: 100,
  AlignerRetainerModel: 100,
  RemovableDieModel: 100,
  ModelCustomBleachingTray: 50,
  OcclusalGuard: 100,
  SurgicalGuide: 100,
  TryInDenture: 100,
  DentureBase: 100,
  HybridDenture: 100,
  DentureTeeth: 100,
  Crown: 100,
  Castable: 100,
  GingivaMask: 100,
  InlayAndOnlay: 100,
  IndirectBondingTray: 100,
  CustomImpressionTray: 170,
  Bridge: 50,
  SmileDesignSnapOn: 100,
  Veneer: 50,
  ImplantCrown: 100,
  Retainer: 170,
  Restorations: 100,
  Unset: 100,
};

export const RecommendedResins = {
  '22': '2018',
  '24': '2004',
  StudyModelSmileDesign: '2004',
  AlignerRetainerModel: '2004',
  RemovableDieModel: '2004',
  ModelCustomBleachingTray: '2004',
  OcclusalGuard: '2008',
  SurgicalGuide: '2011',
  TryInDenture: '2014',
  DentureBase: '2051',
  HybridDenture: '2040',
  DentureTeeth: '2055',
  Crown: '2018',
  Castable: '3004',
  GingivaMask: '2010',
  InlayAndOnlay: '2018',
  IndirectBondingTray: '2007',
  CustomImpressionTray: '2013',
  Bridge: '8002',
  SmileDesignSnapOn: '8002',
  Veneer: '2018',
  ImplantCrown: '2018',
  Retainer: '2066',
  Restorations: '2018',
  Unset: '3010',
};
